import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        fontSize: '26px',
        color: theme.palette.black,
        fontWeight: 'bold',
        marginTop: '170px',
    },
    title: {
        fontSize: '26px',
        color: theme.palette.black,
        fontWeight: 'bold',
    },
}));
